<template>
  <!-- 经典气泡布局：文本、图片、企业名片等 -->
  <div v-if="layout === 'bubble'" class="msgitem" :class="msgItem.isme ? 'me' : 'others'">
    <div v-if="!msgItem.isme" class="avatar">
      <img :src="msgItem.avatar" />
    </div>
    <div class="content">
      <p class="author">
        <i
          v-if="msgItem.isme && msgItem.is_aichat == 1"
          class="iconfont icon-zhinengkefuzhongxin m_ai_icon"></i>
        {{ msgItem.author }}
      </p>
      <div :class="{ me_msg_ontainer: msgItem.isme }">
        <MsgSendStatus :msg-item="msgItem" />
        <MsgContextBody :msg-item="msgItem">
          <slot />
        </MsgContextBody>
      </div>
    </div>
    <div v-if="msgItem.isme" class="avatar">
      <img :src="msgItem.avatar" />
    </div>
  </div>

  <!-- 卡片布局：笔记、视频、语音等 -->
  <div v-else class="msg_container" :class="msgItem.isme ? 'me' : 'others'">
    <div class="flex_center card_item">
      <div class="avatar">
        <img :src="msgItem.avatar" />
      </div>
      <div>
        <div class="card_uname">
          <i
            v-if="msgItem.isme && msgItem.is_aichat == 1"
            class="iconfont icon-zhinengkefuzhongxin m_ai_icon"></i>
          {{ msgItem.author }}
        </div>
        <div class="card_content_container">
          <MsgSendStatus :msg-item="msgItem" />
          <div :class="cardContentClass">
            <MsgContextBody :msg-item="msgItem">
              <slot />
            </MsgContextBody>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MsgSendStatus from "./msgSendStatus.vue";
import MsgContextBody from "./msgContextBody.vue";

export default {
  name: "MsgItemShell",
  components: { MsgSendStatus, MsgContextBody },
  props: {
    msgItem: {
      type: Object,
      default: () => ({}),
    },
    layout: {
      type: String,
      default: "bubble",
      validator: (v) => ["bubble", "card"].includes(v),
    },
    /** 卡片内容区样式变体：default=笔记/视频，audio=语音 */
    variant: {
      type: String,
      default: "default",
      validator: (v) => ["default", "audio"].includes(v),
    },
  },
  computed: {
    cardContentClass() {
      return this.variant === "audio" ? "card_content audio_content_wrap" : "card_content";
    },
  },
};
</script>

<style lang="scss" scoped>
.me_msg_ontainer {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;
}

.msg_container {
  display: flex;
}

.me.msg_container {
  justify-content: flex-end;
}

.others.msg_container {
  justify-content: flex-start;
}

.card_item {
  max-width: 535px;
  word-wrap: break-word;
  word-break: break-all;
}

.me .card_item {
  flex-direction: row-reverse;
  align-items: flex-start;
}

.others .card_item {
  align-items: flex-start;
}

.me .card_uname {
  color: #aaa;
  font-size: 12px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: -3px 10px 3px;
}

.others .card_uname {
  color: #aaa;
  font-size: 12px;
  display: flex;
  justify-content: flex-start;
  margin: -3px 10px 3px;
}

.card_content {
  position: relative;
  background-color: #d6e6f2;
  border-color: #d6e6f2;
  border-radius: 3px;
  padding: 7px 10px;
  font-size: 14px;
}

.me .card_content {
  margin-right: 10px;
}

.others .card_content {
  margin-left: 10px;
}

.card_content_container {
  display: flex;
}

.me .card_content_container {
  justify-content: flex-end;
}

.others .card_content_container {
  justify-content: flex-start;
}

.card_content::after {
  content: "";
  display: inline-block;
  border-width: 5px;
  height: 0;
  width: 0;
  position: absolute;
  top: 10px;
  border-style: solid solid dashed dashed;
  border-color: transparent;
}

.me .card_content::after {
  top: 10px;
  right: -8px;
  border-top-color: inherit;
  border-left-color: inherit;
}

.others .card_content::after {
  top: 10px;
  left: -8px;
  border-top-color: inherit;
  border-right-color: inherit;
}

.audio_content_wrap {
  padding: 0 10px;
}

.me .audio_content_wrap {
  margin-right: 10px;
  background-color: rgba(149, 236, 105, 1);
  border-color: rgba(149, 236, 105, 1);
}

.others .audio_content_wrap {
  margin-left: 10px;
  background-color: #fff;
  border-color: #fff;
}

.me .audio_content_wrap :deep(.audio_content) {
  transform: rotate(180deg);
}

.avatar {
  flex-shrink: 0;
  overflow: hidden;
  height: 35px;
  width: 35px;
}

.avatar img {
  border-radius: 2px;
  vertical-align: top;
  height: 100%;
  width: 100%;
}
</style>
